<!--
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="main-box1">
      <div class="main">
        <div class="join-title">{{ $t('join.text1') }}</div>
        <div class="join-text">
          {{ $t('join.text2') }}<br>
          {{ $t('join.text3') }}
        </div>
        <div class="join-card">
          <div class="box">
            <img class="img" src="/static/images/v2/join/card1.png">
            <div class="text">{{ $t('join.text4') }}</div>
          </div>
          <div class="box">
            <img class="img" src="/static/images/v2/join/card2.png">
            <div class="text">{{ $t('join.text5') }}</div>
          </div>
          <div class="box">
            <img class="img" src="/static/images/v2/join/card3.png">
            <div class="text">{{ $t('join.text6') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box2">
      <div class="main">
        <div class="box2-content">
          <div v-for="(item,index) in $t('join.list')" :key="index">
            {{ item.name }}
            <div class="box2-text">
              <div
                style="width: 6px;height: 6px;background: #D6D6D6;opacity: 0.2;margin-top: 10px;border-radius: 3px;margin-right: 11px"></div>
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-box3" v-if="$i18n.locale === 'zh_CN'">
      <div class="main">
        <div class="title">加入我们</div>
        <div class="email">简历请发送至： hr@hovwing.com</div>
        <div class="box3-content">
          <div class="top-box">
            <div :class="i?'bt2':'bt1'" @click="i=0">社会招聘</div>
            <div :class="i?'bt1':'bt2'" @click="i=1">校园招聘</div>
          </div>
          <div class="box3-grid" v-if="i===1">
            <div v-for="(item,index) in jobList2" :key="index" class="grid-item" @click="getJobDetail(item)">
              <div class="name"> {{ item.name }}</div>
              <div class="text"> {{ item.text }}</div>
              <div class="info" v-for="(i,k) in item.info" :key="k">
                {{ i }}
              </div>
            </div>
            <div  class="grid-item">
              <div style="text-align: center;font-size: 24px;color: #333333;margin-top: 50px;margin-bottom: 40px">更多职位请电话咨询</div>
            </div>
          </div>
          <div class="box3-grid" v-if="i===0">
            <div v-for="(item,index) in jobList1" :key="index" class="grid-item" @click="getJobDetail(item)">
              <div class="name"> {{ item.name }}</div>
              <div class="text"> {{ item.text }}</div>
              <div class="info" v-for="(i,k) in item.info" :key="k">
                {{ i }}
              </div>
            </div>
            <div  class="grid-item" >
              <div style="text-align: center;font-size: 24px;color: #333333;margin-top: 50px;margin-bottom: 40px">更多职位请电话咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <job-detail v-if="dialogVisible" :id="jobId" @closeDialog="dialogVisible=false"></job-detail>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

import JobDetail from "../../join/detail.vue";

export default {
  components: {JobDetail},
  data() {
    return {
      dialogVisible:false,
      jobId: "",
      list: [
        {
          name: '全产业链',
          text: '工业级特种无人机赛道唯一完整掌握飞控、数据链、 光电吊舱、计算机视觉等全产业链关键技术的团队。'
        },
        {
          name: '全领域',
          text: '公司产品可适配全领域载荷，广泛应用于应急、消防、边防、电力、石油、勘探、军工等众多领域。'
        },
        {
          name: '18年+',
          text: '核心团队源于清华，专研飞控、云台等核心技术18年以上，经过上千次算法迭代以及数十万台产品市场考验。'
        },
        {
          name: '自主可控',
          text: '具备自主研发和生产制造能力，形成全面的硬件和软件产品体系，工业无人机核心技术自主可控。'
        }
      ],
      jobList2: [
        {
          'id': "c1",
          'hot': 1,
          text: '北京·海淀/硕士/研发',
          info: ['1. 对飞行系统建模及辨识；', '2. 智能航行路线的规划与设计；'],
          'name': "制导与控制算法工程师"
        },
        {
          'id': "c6",
          'hot': 1,
          text: '北京·海淀/硕士/研发',
          info: ['1. 设计无线通信模块和算法；', '2. 参与无人机无线视频传输设备研发；'],
          'name': "无线通信工程师"
        },
        {
          'id': "c7",
          'hot': 0,
          text: '北京·海淀/硕士/研发',
          info: ['1．负责FPGA代码编写、模块设计以及功能仿真；' ,'2．负责FPGA片内调试，并参与硬件电路调试与测试；'],
          'name': "通信FPGA工程师"
        },

        {
          'id': "c3",
          'hot': 0,
          text: '北京·海淀/硕士/研发',
          info: ['1．图像、视频的目标分类，检测，跟踪；场景识别、分割；人脸检测等算法设计；' ,'2．跟进和应用相关领域前沿技术。'],
          'name': "视觉算法工程师"
        },
        {
          'id': "c4",
          'hot': 0,
          text: '北京·海淀/硕士/研发',
          info:['1．参与嵌入式机器学习平台整体框架设计和实现；' ,'2．针对机器学习主流框架功能增强及性能优化；'],
          'name': "AI平台研发工程师"
        },
        {
          'id': "c2",
          'hot': 0,
          text: '北京·海淀/硕士/研发',
          info: ['1. 对现有产品的维护与升级；' ,'2. 完成新产品的嵌入式系统开发；'],
          'name': "嵌入式软件工程师"
        },
        {
          'id': "c8",
          'hot': 0,
          text: '北京·海淀/硕士/研发',
          info: ['1. 参与新产品设计方案的制定和评审；' ,'2. 产品相关硬件技术文档的编制；'],
          'name': "硬件工程师"
        },
        {
          'id': "c9",
          'hot': 0,
          text: '北京·海淀/硕士/研发',
          info: ['1. 快速拆装结构研究&开发；' ,'2. 机械结构仿真分析及结构强度校验；'],
          'name': "机械结构工程师"
        },
        {
          'id': "c12",
          'hot': 0,
          text: '北京·海淀/本科/研发',
          info: ['1.负责PC平台无人机地面站软件的开发与维护；' ,'2.负责无人机GIS系统的开发与维护；'],
          'name': "地面站软件开发工程师"
        },
        {
          'id': "c11",
          'hot': 0,
          text: '北京·海淀/本科/研发',
          info: ['1. 从事无人机及其相关产品的软件功能，兼容性、可靠性、性能等测试工作;' ,'2. 在需求分析、评审等阶段能够对需求提出合理的优化建议;'],
          'name': "软件测试工程师"
        },
        {
          'id': "c14",
          'hot': 0,
          text: '北京·海淀/专科/销售',
          info: ['1.公司现有客户的维护及新客户的开发；' ,'2.根据公司市场营销战略，积极完成销售指标；'],
          'name': "销售工程师"
        }
      ],
      jobList1: [
        {
          'id': "s1",
          'hot': 1,
          text: '北京·海淀 / 本科 / 研发',
          info: ['1.负责穿越机样机组装、调试、飞行测试及维护;' ,'2.完成性能测试（如稳定性、可靠性测试）并记录问题，独立输出分析报告提交上级;'],
          'name': "FPV穿越机飞控开发工程师"
        },
        {
          'id': "s2",
          'hot': 1,
          text: '北京·海淀 / 硕士 / 研发',
          info: ['1.开发基于视觉、激光雷达或多传感器融合的SLAM算法；' ,'2.优化算法的实时性、鲁棒性和精度，适应复杂场景需求；'],
          'name': "SLAM算法工程师/研究员"
        },
        {
          'id': "s3",
          'hot': 1,
          text: '北京·海淀 / 本科 / 研发',
          info: ['1.\t根据公司产品规划，确定硬件技术路线，完成硬件实现方案（整系统设计，各模块硬件架构、关键器件选型等）；' ,'2.\t根据设计方案，完成硬件原理图设计，指导PCB工程师完成PCB布局&布线、检查审核等工作；'],
          'name': "高级硬件工程师"
        },
        {
          'id': "s4",
          'hot': 0,
          text: '北京·海淀 / 本科 / 研发',
          info: ['1.负责单板硬件原理图设计、元器件选型、PCB设计，BOM文件整理及按要求编写相关文档；' ,'2.负责单板及整机硬件调试；'],
          'name': "初级硬件工程师"
        },
        {
          'id': "s5",
          'hot': 0,
          text: '北京 / 本科 / 研发',
          info: ['1.负责无人机流媒体系统的设计、开发与维护，确保系统的低延迟、高可用性、高性能和稳定性。' ,'2.参与音视频编解码、传输协议等核心技术的研究与优化，提升流媒体服务质量。'],
          'name': "流媒体开发工程师"
        },
        {
          'id': "s6",
          'hot': 0,
          text: '北京 / 本科 / 研发',
          info: ['1、负责无人机整机及部件级结构设计，内部航电堆叠等；' ,'2、负责无人机的承力结构、功能结构设计；'],
          'name': "机械结构工程师"
        },
        {
          'id': "s7",
          'hot': 0,
          text: '北京·海淀 / 本科 / 技术',
          info: ['1. 具备扎实的无人机专业知识，对无人机的原理、性能、应用场景等有深入了解。' ,'2.熟悉低空经济相关政策，能够敏锐捕捉政策动态并快速分析其对业务的影响。'],
          'name': "产品技术支持工程师"
        },
        {
          'id': "s8",
          'hot': 0,
          text: '全国 / 专科 / 销售',
          info: ['1.独立开拓公司无人机行业市场，开发、维护和挖掘销售机会；' ,'2.根据公司市场营销战略，积极完成销售量指标，扩大产品市场占有率；'],
          'name': "行业销售经理"
        },
        {
          'id': "s9",
          'hot': 0,
          text: '全国 / 专科 / 飞手',
          info: ['1. 带领飞行小队，使用油动中型复合翼无人机搭载多种任务载荷完成应急场景下的救灾任务。' ,'2. 与应急管理部门共同制定无人机运维管理规范、应急演练方案、日常训练方案等。'],
          'name': "飞行工程师"
        },
        {
          'id': "s10",
          'hot': 0,
          text: '北京 / 专科 ',
          info: ['1. 按照无人机标准工艺流程进行产品装配；' , '2. 解决装配中电路、结构等简单问题；'],
          'name': "装配工程师"
        },
      ],
      i: 0
    };
  },
  created() {

  },
  mounted() {
    let name=this.$route.name;
    if (name === 'join2') {
      window.scrollTo(0, 2260);
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'join2') {
        window.scrollTo(0, 2260);
      }
    },
  },
  methods: {
    getJobDetail (item) {
      if (item.id === "c00") return false;
      this.dialogVisible = true;
      this.jobId = item.id;
    },
  },
};
</script>

<style lang="stylus" scoped>
.template-container {
  position: relative;
  width: 100%;

  .main {
    width: 1280px;
  }

  .main-box1 {
    width: 100%;
    height: 1050px;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-position: top;
    background-image: url("/static/images/v2/join/join_bg1.png");

    .join-title {
      font-size: 36px;
      font-weight: 500;
      color: #111111;
      margin-top: 180px;
      margin-bottom: 50px;
    }

    .join-text {
      width: 481px;
      font-size: 14px;
      color: #3C3C3C;
      line-height: 24px;
    }

    .join-card {
      margin-top: 100px;
      padding: 22px;
      margin-left: 40px;
      border: 1px solid #FFFFFF;
      background: linear-gradient(180deg, #FFFFFF 5%, #FFFFFF 96%);
      height: 514px;
      border-radius: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 22px;
      row-gap: 22px;

      .box {
        position: relative;
      }

      .img {
        width: 100%;
        height: 100%;
      }

      .text {
        line-height: 57px;
        height: 57px;
        text-align: center;
        width: 100%;
        bottom: 0;
        position: absolute;
        font-size: 18px;
        color: #3C3C3C;
        background: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .main-box2 {
    width: 100%;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-image: url("/static/images/v2/join/join_bg2.png");

    .box2-content {
      margin-top: 200px;
      margin-bottom: 100px;
      margin-left: 52px;
      font-size: 22px;
      font-weight: 600;
      width: 550px;
      color: #fff;
    }

    .box2-text {
      margin-bottom: 60px;
      margin-left: 11px;
      display: flex;
      font-size: 14px;
      line-height: 24px;
    }
  }

  .main-box3 {
    width: 100%;
    display: flex;
    justify-content: center;
    background-size: cover;
    background-position: center;
    background-image: url("/static/images/v2/join/join_bg3.png");

    .title {
      margin-top: 143px;
      margin-bottom: 43px;
      font-size: 36px;
      font-weight: 500;
      color: #111111;
    }

    .email {
      font-size: 18px;
      font-weight: 500;
      color: #111111;
      margin-bottom: 21px;
    }

    .box3-content {
      padding-bottom: 30px;
      margin-bottom: 30px;
      background: #FFFFFF;

      .top-box {
        padding-left: 35px;
        align-items: center;
        height: 70px;
        display: flex;
        line-height: 37px;
        text-align: center;
        border-bottom: 1px solid #EBEBEB;

        .bt1 {
          width: 125px;
          color: #fff;
          cursor: pointer;
          border-radius: 3px;
          background: #1F65FE;
          height: 37px;
        }

        .bt2 {
          width: 125px;
          cursor: pointer;
          border-radius: 3px;
          color: #111;
          height: 37px;
        }
      }
    }

    .box3-grid {
      margin: 19px 35px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 6px;
      row-gap: 6px;

      .grid-item {
        cursor: pointer;
        padding: 20px 30px;
        background: #F7F7F7;
        border-radius: 3px;


        .name {
          margin-bottom: 15px;
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }

        .text {
          margin-bottom: 28px;
          font-size: 14px;
          font-weight: 500;
          color: #666666;
        }

        .info {
          width: 550px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          font-weight: 500;
          color: #999;
          margin-bottom: 15px;
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    position: relative;
    width: 100%;

    .main {
      width: 100%;
    }

    .main-box1 {
      width: 100%;
      height: calc(100vh + 100px);
      display: flex;
      justify-content: center;
      background-size: cover;
      background-position: top;
      background-image: url("/static/images/v2/join/join_bg1.png");

      .join-title {
        margin-left: 5%;
        font-size: 36px;
        font-weight: 500;
        color: #111111;
        margin-top: 80px;
        margin-bottom: 50px;
      }

      .join-text {
        margin-left: 5%;
        width: 90%;
        font-size: 14px;
        color: #3C3C3C;
        line-height: 24px;
      }

      .join-card {
        margin-top: 100px;
        padding: 10px;
        margin-left: 0;
        border: 1px solid #FFFFFF;
        background: linear-gradient(180deg, #FFFFFF 5%, #FFFFFF 96%);
        height: auto;
        border-radius: 10px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 10px;
        row-gap: 10px;

        .box {
          position: relative;
        }

        .img {
          width: 100%;
          height: 100%;
        }

        .text {
          line-height: 14px;
          height: auto;
          text-align: center;
          width: 100%;
          bottom: 0;
          position: absolute;
          font-size: 12px;
          color: #3C3C3C;
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }

    .main-box2 {
      width: 100%;
      display: flex;
      justify-content: center;
      background-size: cover;
      background-position: center;
      background-image: url("/static/images/v2/join/join_bg2.png");

      .box2-content {
        margin-top: 100px;
        margin-bottom: 100px;
        margin-left: 20px;
        font-size: 22px;
        font-weight: 600;
        width: auto;
        color: #fff;
      }

      .box2-text {
        margin-bottom: 60px;
        margin-left: 11px;
        display: flex;
        font-size: 14px;
        line-height: 24px;
      }
    }

    .main-box3 {
      width: 100%;
      display: flex;
      justify-content: center;
      background-size: cover;
      background-position: center;
      background-image: url("/static/images/v2/join/join_bg3.png");

      .title {
        margin-left: 20px;
        margin-top: 83px;
        margin-bottom: 43px;
        font-size: 36px;
        font-weight: 500;
        color: #111111;
      }

      .email {
        margin-left: 20px;
        font-size: 18px;
        font-weight: 500;
        color: #111111;
        margin-bottom: 21px;
      }

      .box3-content {
        padding-bottom: 30px;
        margin-bottom: 30px;
        background: #FFFFFF;

        .top-box {
          padding-left: 35px;
          align-items: center;
          height: 70px;
          display: flex;
          line-height: 37px;
          text-align: center;
          border-bottom: 1px solid #EBEBEB;

          .bt1 {
            width: 125px;
            color: #fff;
            cursor: pointer;
            border-radius: 3px;
            background: #1F65FE;
            height: 37px;
          }

          .bt2 {
            width: 125px;
            cursor: pointer;
            border-radius: 3px;
            color: #111;
            height: 37px;
          }
        }
      }

      .box3-grid {
        margin: 0 0;
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 6px;
        row-gap: 6px;

        .grid-item {

          cursor: pointer;
          padding: 20px 30px;
          background: #F7F7F7;
          border-radius: 3px;


          .name {
            margin-bottom: 15px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
          }

          .text {
            margin-bottom: 28px;
            font-size: 14px;
            font-weight: 500;
            color: #666666;
          }

          .info {
            width: 90vw;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            font-weight: 500;
            color: #999;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/join/index.vue